import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AvailabilityDatesTypeDisplayNameMap } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/date-picker/model';
import { DatePickerExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'date-picker-availability-dates',
  templateUrl: './date-picker-availability-dates.component.html',
  styleUrls: ['./date-picker-availability-dates.component.scss'],
  standalone: false,
})
export class DatePickerAvailabilityDatesComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  availabilityDatesTypeOptions = [
    {
      label: AvailabilityDatesTypeDisplayNameMap[DatePickerExtension.AvailableDateType.BUSINESS_DAYS],
      value: DatePickerExtension.AvailableDateType.BUSINESS_DAYS,
    },
    {
      label: AvailabilityDatesTypeDisplayNameMap[DatePickerExtension.AvailableDateType.CALENDAR_DAYS],
      value: DatePickerExtension.AvailableDateType.CALENDAR_DAYS,
    },
  ];

  constructor() {}
  ngOnDestroy() {}

  ngOnInit() {}
}
